import { arrayUnion, doc, getDoc, setDoc, updateDoc } from 'firebase/firestore'
import { db } from "./firebase.config";

export const getUser = async (uid) => {
    try {
        const userDoc = await getDoc(doc(db, "users", uid));

        if (userDoc.exists()) {
            return userDoc.data();
        } else {
            throw new Error("No such user with this uid!");
        }
    } catch (error) {
        console.error("Error fetching user data:", error);
        throw error;
    }
};

export const createUser = async (uid, data) => {
    try {
        await setDoc(doc(db, "users", uid), data);
    } catch (error) {
        console.error("Error creating user:", error.message);
        throw error;
    }
};

export const updateUser = async (uid, data) => {
    try {
        const userRef = doc(db, "users", uid);

        await updateDoc(userRef, data);
    } catch (error) {
        console.error("Error updating user:", error.message);
        throw error;
    }
};

export const addSubscription = async (uid, subscriptionId) => {
    try {
        const userRef = doc(db, "users", uid);

        await updateDoc(userRef, {
            subscriptions: arrayUnion(subscriptionId)
        });
    } catch (error) {
        throw error;
    }
};